import BuyerChecklistItem from "./BuyerChecklistItem";

export default function BuyerChecklistSection({
  section,
  checkedMap = {},
  onToggle,
  compact = false,
  showImportance = false,
  defaultOpen = true,
  listingId = null,
  dealerId = null,
  defaultVehicleContext = null,
  highlightItemIds = null,
}) {
  if (!section?.items?.length) return null;

  return (
    <section className="buyer-checklist-section" id={section.id}>
      <details className="buyer-checklist-section__details" open={defaultOpen}>
        <summary className="buyer-checklist-section__summary">
          <div>
            <h2 className="buyer-checklist-section__title">{section.title}</h2>
            {section.description ? (
              <p className="buyer-checklist-section__description">{section.description}</p>
            ) : null}
          </div>
        </summary>
        <ul className="buyer-checklist-section__list">
          {section.items.map((item) => (
            <BuyerChecklistItem
              key={item.id}
              item={item}
              checked={checkedMap[item.id]}
              onToggle={onToggle}
              compact={compact}
              showImportance={showImportance}
              listingId={listingId}
              dealerId={dealerId}
              defaultVehicleContext={defaultVehicleContext}
              highlighted={highlightItemIds?.has?.(item.id)}
            />
          ))}
        </ul>
      </details>
    </section>
  );
}
